export default {"src":"/_next/static/media/starpattern.b7646101.svg","height":1081,"width":1881,"blurWidth":0,"blurHeight":0};